// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2e7bS","col":"styles_col__SWLgN"};